import { xlsxTypes } from "./xlsxTypes"

const {
  SET_XLSX,
  REMOVE_XLSX,
  UPDATE_XLSX,
  UPDATE_XLSX_ERROR,
  CLEAN_XLSX,
  RESET_XLSX_STATE
} = xlsxTypes
const initialState = {
  xlsx: [],
}
export const xlsxReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_XLSX:
      return {
        ...state,
        xlsx: [
          ...state.xlsx,
          payload
        ],
      }

    case REMOVE_XLSX:
      return {
        ...state,
        xlsx: state.xlsx.filter(item => item.id !== payload),
      }

    case UPDATE_XLSX:
      let updateState = state.xlsx
      const index = updateState.findIndex(item => item.id === payload.id)
      if (index === -1) return state;
      updateState[index] = {
        ...updateState[index],
        url: payload.url,
      }
      return {
        ...state,
        xlsx: updateState,
      }

    case UPDATE_XLSX_ERROR:
      let updateError = state.xlsx
      const idx = updateError.findIndex(item => item.id === payload.id)
      if (idx === -1) return state;
      updateError[idx] = {
        ...updateError[idx],
        validFile: false,
        errorMessage: payload.error
      }
      return {
        ...state,
        xlsx: updateError,
      }

    case CLEAN_XLSX:
      return {
        ...state,
        xlsx: state.xlsx.filter(fl => fl.validFile),
      }

    case RESET_XLSX_STATE:
      return initialState
    default:
      return state;
  }
}